export const colors = {
  main: '#7366FF',
}
